import React, { Component } from "react";
import ServiceListSocial from "../service/ServiceListSocial";

class ContactOne extends Component{
    constructor(props){
        super(props);
        this.state = {
            rnName: '',
            rnEmail: '',
            rnSubject: '',
            rnMessage: '',
        };
    }
    render(){
        const linkedinUrl = "https://www.linkedin.com/in/temefford";
        const githubUrl = "https://www.github.com/temefford";
        return(
            <div className="contact-form--1">
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50 ptb--80">
                                <h2 className="title">Get in touch.</h2>
                            </div>
                        </div>
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <p className="description">Please feel free to contact me with any question. The best way to reach me is through the contact form.</p>
                                <p className="description">
                                    You can also find me on{" "}
                                    <a href={linkedinUrl} target="_blank" rel="noopener noreferrer">LinkedIn</a>
                                    {" "}and{" "}
                                    <a href={githubUrl} target="_blank" rel="noopener noreferrer">GitHub</a>.
                                </p>
                                <div className="col-lg-12">
                                    <ServiceListSocial item="2" column="col-lg-4 col-md-6 col-sm-6 col-12 text-center" />
                                </div> 
                            </div>                          
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactOne;
